import React from "react";

export default class ItemButtonEmpty extends React.Component {
  render() {
    return <div style={{ width: 30 }}></div>;
  }
}
